import { QueryClient } from "@tanstack/solid-query";

// On the server every request must get its own QueryClient so cached query data
// from one user/request never leaks into another. On the client we reuse a
// single instance across navigations so the cache survives route transitions.
let cached: { queryClient: QueryClient } | undefined;

function makeClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // The app refetches on explicit invalidation and on mount; refetching
        // every stale query on window focus / reconnect is pure waste for
        // data that changes rarely (chart of accounts, business detail, etc.)
        // and was driving repeated DB calls on every tab switch.
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });
}

export function getContext() {
  if (typeof window === "undefined") {
    // Server: always return a fresh instance — never cache across requests.
    return { queryClient: makeClient() };
  }
  if (!cached) {
    cached = { queryClient: makeClient() };
  }
  return cached;
}
